export default (size, weight, color) => {
  return `
    font-family: 'Roboto', sans-serif;
    font-size: ${size}px;
    font-weight: ${weight};
    color: ${color};
  `
}
